// Putting the keyboard on the page: the skip link, and a Jump to choice.
//
// # WHY THE BROWSER IS TOLD NOT TO SCROLL
//
// focus() scrolls what it focuses into view, and the page is taller than the
// window, so a browser brings its top edge to the top of the window. The top
// bar is sticky and 56 px tall, so that put every page's title under it: the
// skip link did it on any screen, and a Jump to choice left the page a few
// pixels down, wherever its 8 px entry animation had got to (measured in
// Chrome, 11 October 2026).
//
// The page asked for is shown from its top, so the focus moves without a
// scroll and the window is put there. Nothing else may focus #main.
type FocusTarget = { focus: (options?: { preventScroll?: boolean }) => void }

export function focusPage(
  doc: { getElementById: (id: string) => FocusTarget | null } = document,
  win: { scrollTo: (x: number, y: number) => void } = window,
): void {
  doc.getElementById('main')?.focus({ preventScroll: true })
  win.scrollTo(0, 0)
}
